import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './productstyle.css';
import bgimage from '../../Assets/bg1.jpg';
import api from '../../axiosInstance';
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useMediaQuery } from '@mui/material';
import { Button, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DistriProductPrice from '../PriceList/DistriProductPrice';


function ProductComponent() {
  const isMobile = useMediaQuery('(max-width:600px)');

  const parent_id = Number(sessionStorage.getItem('providerId'));
  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    description: '',
    code: '',
    price: '',
  });

  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [page, setPage] = useState(1);
  const [productPage, setProductPage] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const providerId = sessionStorage.getItem('providerId');
  const userid = sessionStorage.getItem('userid');
  let url = providerId !== '0' ? `/userproduct?DISID=${userid}` : `/products?page=${page}`

  useEffect(() => {
    fetchProducts(page);
  }, [page]);
  console.log("PP", parent_id, typeof parent_id);
  // Fetch Products
  const fetchProducts = async () => {
    try {
      let url = providerId !== '0' ? `/userproduct?DISID=${userid}` : `/products?page=${page}`
      const response = await api.get(url);
      const filteredlink = response.data.meta.links.filter(link => /^[0-9]+$/.test(link.label))
      const updatedfilteredlinks = filteredlink.map(link => ({
        ...link,
        active: parseInt(link.label) == page
      }))
      console.log("products res", response)
      setProductPage(updatedfilteredlinks)
      setProducts(response.data.data || []);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };


  console.log("Product data",products)

  // Handle Input Change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {

        // Update Product
        const response = await api.put(`/products/${formData.id}`, formData);
        console.log("Res", response);
        if (response.status === 200) {
          alert('Product updated successfully!');
        }
      } else {
        // Create Product
        const response = await api.post('/products', formData);
        if (response.status === 200) {
          alert('Product added successfully!');
        }
      }
      setShowForm(false);
      fetchProducts(); // Refresh products list
      resetForm();
    } catch (error) {
      alert(`Error: ${error.response?.data?.error || error.message}`);
    }
  };

  // Handle Edit
  const handleEdit = (product) => {
    // console.log("Edit Clicked", product);
    setFormData(product);
    setShowForm(true);
    setIsEditing(true);
  };

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      try {
        await api.delete(`/products/${id}`);
        alert('Product deleted successfully!');
        fetchProducts(); // Refresh the product list
      } catch (error) {
        alert(`Error: ${error.response?.data?.error || error.message}`);
      }
    }
  };

  // Reset Form
  const resetForm = () => {
    setFormData({ id: '', name: '', description: '', code: '', price: '' });
    setIsEditing(false);
  };


  const handlePageChange = (newPage) => {

    // setPage(newPage);
    if (newPage !== page) {
      setPage(newPage);
    }

  };

  const CustomPagination = () => (
    <>
      <div className='d-flex justify-content-center'>
        <Button
          size="small"
          variant="contained"
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          sx={{ padding: "2px 6px", minWidth: "30px" }} // Reduced padding

        // sx={{ marginRight: 2 }}
        >
          {/* Previous */}
          <ArrowBack fontSize="small" />

        </Button>


        {(productPage?.length > 0 ? productPage : [{ label: "1", active: true }, { label: "2", active: false }]).map((link, index) => (
          <Button
            size="small"
            key={index}
            variant={link.active ? "contained" : "outlined"}
            color={link.active ? "primary" : "default"}
            onClick={() => handlePageChange(parseInt(link.label))}
            sx={{ marginX: "2px", padding: "2px 6px", minWidth: "30px", marginLeft: 1 }}
          >
            {link.label}
          </Button>
        ))}
        <Button
          size="small"
          variant="contained"
          onClick={() => handlePageChange(page + 1)}
          disabled={productPage.length === 0 || page >= productPage.length}
          sx={{ padding: "2px 6px", minWidth: "30px", marginLeft: 1 }} // Reduced padding

        // sx={{ marginLeft: 2 }}
        >
          {/* Next */}
          <ArrowForward fontSize="small" />

        </Button>
      </div>
    </>
  );


  return (

    <div className="row productfont" style={{ height: "100%" }}>
      <div className="col-md-12 col-12 " style={{ position: "relative", height: "100%" }}>
        {showForm ? (
          <div className="divheight">
            <h3>{isEditing ? 'Edit Product' : 'Add Product'}</h3>
            <div className="productbgimage divheight rounded-3 shadow d-flex justify-content-center align-items-start">
              <div className="formwidthBgImage py-1 px-5 m-3 shadow rounded-4">
                <form onSubmit={handleSubmit}>
                  ...
                  <div className="d-flex justify-content-end align-items-center py-2">
                    <button
                      type="button"
                      className="btn btn-secondary m-1"
                      onClick={() => {
                        setShowForm(false);
                        resetForm();
                      }}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary m-1">
                      {isEditing ? 'Update' : 'Submit'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-9">
                <h3>Product</h3>
              </div>
              {/* <div className='d-flex justify-content-end align-items-center'>
                <button className='btn btn-primary' onClick={() => navigate(`/createpricelist`)}>Crete Pricelist</button>
              </div> */}
              {/* {parent_id === 0 && ( // Show only if parent_id is 0
                <div className="col-12 text-end align-items-end p-2 m-1">
                  <button
                    type="button"
                    className="rounded btnproduct"
                    onClick={() => {
                      setShowForm(true);
                      resetForm();
                    }}
                  >
                    Add Product
                  </button>
                </div>
              )} */}

            </div>

            <div className="row product-list-container">
              {products.map((product) => (
                <div className="col-sm-12 col-md-4">
                  <div className="card overflow-hidden rounded-5 shadow-lg mb-5 bg-body-tertiary rounded">
                    <img src={bgimage} className="card-img-top" alt={product.name} height={150} />
                    <div className="m-2">
                      <h5 className="m-0">{product.name || product?.product_name}</h5>
                      <p className="m-0">{product.description}</p>
                      <p className="m-0">
                        {!product?.product_name && (
                          <>
                            <strong>Code:</strong> {product.code}
                          </>
                        )}

                      </p>
                      <p className="m-0" style={{ fontFamily: 'cursive' }}>
                        <strong>Price:</strong> ₹{product?.price || product?.latestpricelist?.price}
                      </p>
                      {/* {parent_id === 0 && ( // Hide Edit & Delete buttons if parent_id is not 0
                        <div className="text-end align-items-right">
                          <button
                            className="btnget p-1 m-2 rounded-3 shadow-lg"
                            onClick={(e) => { e.preventDefault(); handleEdit(product); }}
                          >
                            Edit
                          </button>
                          <button
                            className="btnget p-1 m-2 rounded-3 shadow-lg"
                            onClick={(e) => { e.preventDefault(); handleDelete(product.id); }}
                          >
                            Delete
                          </button>
                        </div>
                      )} */}
                      {/* <button
                        className="btnget p-1 m-1 rounded-3 shadow-lg"
                      > */}
                      {/* {parent_id !== 0 && <button>
                        <DistriProductPrice />
                      </button>} */}


                      {/* </button> */}
                      {/* <button
                        className="btnget p-1 m-1 rounded-3 shadow-lg"
                        style={{fontSize:'10px'}}
                        onClick={() => navigate(`/assignreseller`)}
                      >
                        Assign Price List
                      </button>
                      <button
                        className="btnget p-1 m-1 rounded-3 shadow-lg"
                        style={{fontSize:'10px'}}
                        onClick={() => navigate(`/createpricelist`)}
                      >
                       Create Price List
                      </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        <div className={isMobile ? 'pagination-mobile' : 'pagination-content'}>
          <CustomPagination />
        </div>
      </div>
      {/* <div
        className="col-md-3 col-12 rounded-5 mt-md-0 mt-2 divheight"
        style={{
          backgroundImage: `url(${bgimage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="bg-white my-4 mx-2 p-3 rounded-5">
          <h5>Details</h5>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum
            tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis
            reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.
          </p>
        </div>
      </div> */}
    </div>
  );
}

export default ProductComponent;
